export interface ErrorDetails {
  timestamp: Date;
  message: string;
  microservice: string;
  stacktrace: string;
  idClient: number;
  idUtilisateur: number;
}


export class ErrorInfos {
  constructor(public title: string, public content: string)  {}
}


export class MicroserviceError extends ErrorInfos{
  constructor(public title: string,
              public content: string,
              public details: ErrorDetails)  {
    super(title, content)
  }

}

